// @ts-check
import angular from 'angular'
import ctrl from './companies.ctrl'
import template from './companies.html'
import { CreateCompanyController } from './inbounds/accountCreation.ctrl.js'
import inbounds from './inbounds/accountCreation.html'
import './inbounds/accountCreation.css'
import './companies.css'
import createCompanyMenu from './inbounds/createCompanyMenu.html'
import mainMenu from '../../shared/menu/menu.html'
import menu from './menu.html'

export default angular.module('companies', ['ui.router'])
  .filter('numKeys', function () {
    return function (json) {
      var keys = Object.keys(json)
      return keys.length
    }
  })
  .filter('trim', function () {
    return function (value) {
      if (!angular.isString(value)) {
        return value
      }
      return value.replace(/^\s+|\s+$/g, '')
    }
  })
  .directive('mdtCustomCellButton', function () {
    return {
      template: '<md-button class="md-icon-button" aria-label="edit"><md-icon>format_list_numbered</md-icon><md-tooltip>View/Create Positions</md-tooltip></md-button>'
    }
  })
  .directive('mdtCustomCellEdit', function () {
    return {
      template: '<md-button class="md-icon-button" aria-label="edit"><md-icon>mode_edit</md-icon><md-tooltip>Edit Company</md-tooltip></md-button>'
    }
  })
  .directive('mdtCustomCellUsers', function () {
    return {
      template: '<md-button class="md-icon-button" aria-label="Settings"><md-icon>supervisor_account</md-icon><md-tooltip>Company Users</md-tooltip></md-button>'
    }
  })
  .config(function ($stateProvider) {
    'ngInject'

    $stateProvider.state('app.companies', {
      url: '/companies',
      views: {
        content: {
          template: template,
          controller: ctrl,
          controllerAs: 'c',
          resolve: {
            companies: (Companies) => {
              'ngInject'

              return Companies.getCompaniesData()
            },
            user: (Auth) => {
              'ngInject'
              return Auth.getDetails()
            },
            regions: (Region) => {
              'ngInject'

              return Region.getRegions()
            }
          }
        },
        menu: {
          template: mainMenu + menu
        }
      }
    })
    .state('app.createCompany', {
      url: '/createCompany',
      resolve: {
        companies: (Companies) => {
          'ngInject'

          return Companies.getCompaniesData()
        },
        regions: (Region) => {
          'ngInject'

          return Region.getRegions()
        }
      },
      views: {
        content: {
          controller: CreateCompanyController,
          controllerAs: 'new',
          template: inbounds
        },
        menu: {
          template: createCompanyMenu
        }
      }
    })
  })
